<template>
  <section>
    <div class="sticky-wrapper">

      <div class="warning-panel" v-if="(getWarningPanelText != '')">
        <img :src="'//' + currentURL + '/app/themes/leightons/images/warning-icon.svg'"/>
        <div v-html="getWarningPanelText"></div>
      </div>
      <h2>To start, choose the service you would like to book:</h2>

      <ul>
        <li v-for="(service, index) in appointment.services" :key="service.code">
          <label :for="service.code" @click="selectService(service, index)" :class="{active: appointment.service.code === service.code}">
            <h3>{{service.title}}</h3>
            <p v-if="service.description != ''">{{service.description}}</p>
            <p class="price" v-if="(service.price && service.price != '')">{{service.price}}</p>
          </label>
        </li>
      </ul>
    </div>

    <div class="btn-container">
      <button :disabled="appointment.service.id === ''" @click="onContinue" class="btn">Continue</button>
    </div>
  </section>
</template>

<script>
export default {
  created() {
    this.currentURL = location.host;
  },
  name: "BookingService",
  props: ["appointment"],
  methods: {
    onContinue() {
      this.addToGTMDataLayer(this.appointment.service, -1, "add");
      if (this.$route.query.practice && this.appointment.practice && this.appointment.practice.post_name === this.$route.query.practice.toLowerCase()) {
        this.stage('date');
      } else {
        this.stage('location');
      }
    },
    stage(stage) {
      this.$emit("stage", stage);
    },
    selectService(service, index) {
      this.$emit('selectService', service);
      this.addToGTMDataLayer(service, index, "click");
    },
    addToGTMDataLayer(service, index, type) {
      if (service && service.id && service.id !== "") {

        window.dataLayer = window.dataLayer || [];
        if (type === "click") {
          window.dataLayer.push({
            'event': 'eec.impressionClick',
            'ecommerce': {
              'click': {
                  actionField: {
                    'list': 'Booking Type'
                  },
                  products:[{
                    'name': service.title,
                    'id': service.id,
                    'price': service.price ?? '',
                    'brand': 'Leightons Opticians & Hearing Care',
                    'category': 'Hearing Services',
                    'position': index+1
                }]
              }
            }
          });
        } else if (type === "add") {
          window.dataLayer.push({
            'event': 'eec.add',
            'ecommerce': {
              'add': {
                  actionField: {
                    'list': 'Booking Type'
                  },
                  products:[{
                    'name': service.title,
                    'id': service.id,
                    'price': service.price ?? '',
                    'quantity': 1,
                    'brand': 'Leightons Opticians & Hearing Care',
                    'category': 'Hearing Services',
                }]
              }
            }
          });
        }
      }
    }
  },
  computed: {
    getWarningPanelText() {
      if (this.appointment.bookingConfigs && this.appointment.bookingConfigs.warning_panel_text != '') {
        return this.appointment.bookingConfigs.warning_panel_text;
      }
      return "";
    }
  },
  mounted() {
    window.scrollTo(0, 0);
  }
};
</script>

<style lang="postcss" scoped>
section {
  @apply relative;

  .sticky-wrapper {

    @apply lg:max-w-[1300px] mx-auto px-8 pad:px-0 pt-10;
  }

  &:deep .warning-panel {
    @apply w-full rounded-[20px] border-2 border-pink-darker  bg-pink-lighter flex flex-row justify-center items-start sm:items-center p-4 mb-10;

    p,div {
      @apply ml-5;

      strong {
        @apply text-pink-darker uppercase font-avenir-black tracking-wide;
      }
    }
  }



  .btn-container {
    @apply sticky inset-x-0 bottom-0 bg-white shadow-md flex justify-center items-center h-[110px] px-[30px];
    box-shadow: 0 -4px 4px rgba(0, 0, 0, 0.1);

    button.btn {
      @apply w-full sm:w-auto rounded-none;
    }
  }

  h2 {
    @apply max-w-[600px] mx-auto text-center border-b border-purple-darker pb-8 sm:pb-9;
  }

  ul {
    @apply block sm:grid sm:grid-cols-2 lg:grid-cols-3 gap-12 my-[45px];

    li {
      @apply mb-5 last:mb-0 sm:mb-0;

      label {
        @apply border-2 sm:min-h-[250px] sm:h-full transition-colors cursor-pointer block p-5 sm:p-10 bg-white border-aqua rounded-[10px];
        box-shadow: 0px 3px 15px rgba(0,0,0,0.16);

        &.active {
          @apply border-2 border-pink bg-pink-lighter;
        }

        p {
          @apply mb-[14px] last:mb-0;

          &.price {
            @apply text-[#446481] text-[15px] leading-[20px];
          }
        }
      }
    }
  }
}
</style>